import {createPinia} from 'pinia'
import {useGlobalStore} from '@/pinia/modules/global'
import {useGameStore} from '@/pinia/modules/game'
import {useMemberStore} from '@/pinia/modules/member'

const store = createPinia()

export {
    store,
    useGlobalStore,
    useGameStore,
    useMemberStore,
}